import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { getFaviconUrl, isExternalHttpUrl } from '../utils/links';

const escapeCssUrl = (value: string): string => value.replace(/["\\]/g, '\\$&');

export const EditorLinkFavicons = Extension.create({
    name: 'editorLinkFavicons',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('editorLinkFavicons'),
                props: {
                    decorations(state) {
                        const ranges: Array<{ from: number; to: number; href: string }> = [];

                        state.doc.descendants((node, pos) => {
                            if (!node.isText) {
                                return;
                            }
                            const link = node.marks.find((mark) => mark.type.name === 'link');
                            const href = link?.attrs?.href;
                            if (!href || !isExternalHttpUrl(href)) {
                                return;
                            }
                            const from = pos;
                            const to = pos + node.nodeSize;
                            const last = ranges[ranges.length - 1];
                            if (last && last.to === from && last.href === href) {
                                last.to = to;
                            } else {
                                ranges.push({ from, to, href });
                            }
                        });

                        const decorations = ranges.map((range) => {
                            const favicon = getFaviconUrl(range.href);
                            return Decoration.inline(range.from, range.to, {
                                class: 'task-content-link-favicon-host',
                                style: favicon
                                    ? `--link-favicon: url("${escapeCssUrl(favicon)}")`
                                    : undefined,
                            }, {
                                inclusiveStart: false,
                                inclusiveEnd: false,
                            });
                        });

                        return DecorationSet.create(state.doc, decorations);
                    },
                },
            }),
        ];
    },
});
